export default {
  name: "About"
};
